import { isTableOfContentsOpened } from '../tableOfContents/selectors'
import { closeAllLeftAsides } from '../aside/actions'

export const INIT_TABLE_OF_CONTENTS = 'INIT_TABLE_OF_CONTENTS'
export function initTableOfContents(tableOfContents)
{
    return function initTableOfContents(dispatch)
    {
        dispatch({ type: INIT_TABLE_OF_CONTENTS, tableOfContents })
    }
}

export function toggleTableOfContents()
{
    return function toggleTableOfContents(dispatch, getState)
    {
        if(isTableOfContentsOpened(getState()))
        {
            dispatch(closeTableOfContents())

            return
        }

        dispatch(openTableOfContents())
    }
}

export const OPEN_TABLE_OF_CONTENTS = 'OPEN_TABLE_OF_CONTENTS'
export function openTableOfContents()
{
    return function openTableOfContents(dispatch)
    {
        dispatch(closeAllLeftAsides())
        dispatch({ type:  OPEN_TABLE_OF_CONTENTS })
    }
}

export const CLOSE_TABLE_OF_CONTENTS = 'CLOSE_TABLE_OF_CONTENTS'
export const closeTableOfContents = () => ({ type:  CLOSE_TABLE_OF_CONTENTS })
